import {
  Component, Inject, OnInit, OnDestroy, AfterViewInit,
  ChangeDetectorRef, NgZone
} from '@angular/core';
import {
  FormGroupDirective, UntypedFormControl, ControlContainer,
  Validators, UntypedFormGroup, UntypedFormBuilder
} from '@angular/forms';
import { TimeApiService } from 'cbc-shared-lib';
import { MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { MoneyFormatService } from '../../../../../../sg-base/sg-base-shared/services/money-format.service';

@Component({
  selector: 'app-sgkb714d-bulkset',
  templateUrl: './sgkb714d-bulkset.component.html',
  styleUrl: './sgkb714d-bulkset.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class Sgkb714dBulksetComponent implements OnInit, OnDestroy, AfterViewInit {

  /** 親コンポーネント保持領域 */
  parentForm: UntypedFormGroup | null = null;;
  /** 自コンポーネント領域 */
  priceInputRegistForm: UntypedFormGroup;

  private onDestroy$ = new Subject();

  /** 割引・割増開始日 */
  waribikiKaishiYMD: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 割引・割増解除日 */
  waribikiKaijoYMD: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 割引・割増金額 */
  waribikiKingaku: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 割引・割増率 */
  waribikiRitsu: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  showKingaku: boolean = true;

  /** 割引・割増金額(小数点編集) */
  private prevVal = '';
  /** 割引・割増金額（カンマ編集） */
  readonly constNumberCommaMaxLength1: number = 5;
  numberCommaMaxLength1: number = this.constNumberCommaMaxLength1;
  /** 割引・割増率（カンマ編集） */
  readonly constNumberCommaMaxLength2: number = 5;
  numberCommaMaxLength2: number = this.constNumberCommaMaxLength2;

  constructor(
    private fb: UntypedFormBuilder,
    private parent: FormGroupDirective,
    public _dialogRef: MatDialogRef<Sgkb714dBulksetComponent>,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private moneyFormatService: MoneyFormatService,
    private timeApiService: TimeApiService,
    @Inject(MAT_DIALOG_DATA) private data: {
      send: boolean, mode: string, startDate: string, unlockDate: string,
      mny: string, rate: string, registFlg: boolean
    },
  ) { }

  /**
   * 初期処理
   * @memberof Sgkb714dBulksetComponent
   */
  ngOnInit(): void {
    this.priceInputRegistForm = this.fb.group({
      waribikiKaishiYMD: this.waribikiKaishiYMD,
      waribikiKaijoYMD: this.waribikiKaijoYMD,
      waribikiKingaku: this.waribikiKingaku,
      waribikiRitsu: this.waribikiRitsu,
    });
    this.parentForm = this.parent.form;
    this.parentForm.addControl('priceInputRegistForm', this.priceInputRegistForm);

    this.configureFormControls();
  }

  /**
   * コンポーネントのビュー初期化直後の処理
   * @memberof Sgkb714dBulksetComponent
   */
  ngAfterViewInit(): void {
    // 非同期処理の変更点を制御（ExpressionChangedAfterItHasBeenCheckedErrorの回避）
    this.ngZone.run(() => {
      // 自コンポーネント内のフォーム状態を最新化
      this.priceInputRegistForm.updateValueAndValidity();
      // 変更検出を行い、ビューとデータの整合性を確保
      this.cdr.detectChanges();
    });
  }

  /**
   * 購読を停止する処理
   * @memberof Sgkb714dBulksetComponent
   */
  configureFormControls(): void {
    const { send, mode, startDate, unlockDate, mny, rate, registFlg } = this.data;

    this.priceInputRegistForm.controls['waribikiKaishiYMD'].enable();
    this.priceInputRegistForm.controls['waribikiKingaku'].enable();
    this.priceInputRegistForm.controls['waribikiRitsu'].enable();
    // 割引・割増開始日のDate型変換
    const waribikiStartDate = this.timeApiService.convertStringToDate(startDate);
    const waribikiUnlockDate = this.timeApiService.convertStringToDate(unlockDate);

    // 親画面：定額割引、環境貢献加算 選択時
    if (send) {
      // 割引・割増金額を表示
      this.showKingaku = true;
      // 割引・割増開始日に遷移パラメータの値を設定する
      this.priceInputRegistForm.controls['waribikiKaishiYMD'].setValue(waribikiStartDate)
      this.priceInputRegistForm.controls['waribikiKaishiYMD'].setValidators(Validators.required);
      // 割引・割増解除日に遷移パラメータの値を設定する
      this.priceInputRegistForm.controls['waribikiKaijoYMD'].setValue(waribikiUnlockDate)
      // 割引・割増金額がnullまたは空の場合は何もしない
      let targetMny = mny;
      if (mny != null && mny != '') {
        // 小数点があり、かつ小数部が1桁の場合は末尾に0を付与
        if (/^\d+\.\d$/.test(mny)) {
          targetMny = mny + '0';
        }
        // 小数点がなく 1〜2桁の整数の場合は末尾に.00を付与
        else if (!mny.includes('.') && /^\d{1,2}$/.test(mny)) {
          targetMny = mny + '.00';
        }
      }
      // 割引・割増金額に遷移パラメータの値を設定する
      this.priceInputRegistForm.controls['waribikiKingaku'].setValue(targetMny)
      this.priceInputRegistForm.controls['waribikiKingaku'].setValidators(Validators.required);
      // 割引・割増金率を無効化
      this.waribikiRitsu.disable();

      // 遷移パラメータ：期中契約変更 割引割増開始日：null、空以外
      if (mode == 'midterm_change' && registFlg != true) {
        // 割引・割増開始日、割引・割増金額を非活性
        this.priceInputRegistForm.controls['waribikiKaishiYMD'].disable();
        this.priceInputRegistForm.controls['waribikiKingaku'].disable();
      }
    }
    // 親画面：定率割引、定率割増 選択
    else {
      // 割引・割増率を表示
      this.showKingaku = false;
      // 割引・割増開始日に遷移パラメータの値を設定する
      this.priceInputRegistForm.controls['waribikiKaishiYMD'].setValue(waribikiStartDate)
      this.priceInputRegistForm.controls['waribikiKaishiYMD'].setValidators(Validators.required);
      // 割引・割増解除日に遷移パラメータの値を設定する
      this.priceInputRegistForm.controls['waribikiKaijoYMD'].setValue(waribikiUnlockDate)
      // 割引・割増率に遷移パラメータの値を設定する
      this.priceInputRegistForm.controls['waribikiRitsu'].setValue(rate)
      this.priceInputRegistForm.controls['waribikiRitsu'].setValidators(Validators.required);
      // 割引・割増金額を無効化
      this.waribikiKingaku.disable();

      // 遷移パラメータ：期中契約変更 割引割増開始日：null、空以外
      if (mode == 'midterm_change' && registFlg != true) {
        // 割引・割増開始日、割引・割増率を非活性
        this.priceInputRegistForm.controls['waribikiKaishiYMD'].disable();
        this.priceInputRegistForm.controls['waribikiRitsu'].disable();
      }
    }
    this.waribikiKingaku.updateValueAndValidity();
    this.waribikiRitsu.updateValueAndValidity();
    this.ngAfterViewInit();
  }

  /**
   * 購読を停止する処理
   * @memberof Sgkb714dBulksetComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('priceInputRegistForm');
  }

  /**
   * 閉じるボタン押下処理
   * @memberof Sgkb714dBulksetComponent
   */
  onClickCancel(): void {
    this._dialogRef.close();
  }

  /**
   * OKボタン押下処理
   * @memberof Sgkb714dBulksetComponent
   */
  onClickOk(): void {
    this._dialogRef.close(this.priceInputRegistForm.controls);
  }

  /**
   * フォーカスアウト時編集
   * @memberof Sgkb714dBulksetComponent
   */
  onBlurNumberEdit(targetItem: string): void {
    const ctrl = this.priceInputRegistForm.controls[targetItem];
    // 整数部2桁、小数点2桁まで許容
    const regex = /^\d{1,2}\.\d{2}$/;

    // 割引・割増金額がnullまたは空の場合は何もしない
    if (this.priceInputRegistForm.controls[targetItem].value == null
      || this.priceInputRegistForm.controls[targetItem].value == '') {
      return;
    }
    const preTargetMoney: string = this.priceInputRegistForm.controls[targetItem].value.toString();
    let targetMoney: string = this.priceInputRegistForm.controls[targetItem].value.toString();
    // 末尾が.(ドット)だった場合は、末尾に00を付与
    if (preTargetMoney.endsWith('.')) {
      targetMoney = targetMoney + '00';
    }
    // 小数点があり、かつ小数部が1桁の場合は末尾に0を付与
    else if (/^\d+\.\d$/.test(preTargetMoney)) {
      targetMoney = preTargetMoney + '0';
    }
    // 小数点がなく 1〜2桁の整数の場合は末尾に.00を付与
    else if (!preTargetMoney.includes('.') && /^\d{1,2}$/.test(preTargetMoney)) {
      targetMoney = preTargetMoney + '.00';
    }

    if (!regex.test(targetMoney)) {
      // 上記以外の場合は直前の値に戻す
      targetMoney = preTargetMoney;
      // エラーを返却する
      const currentErrors = { ...(ctrl.errors || {}) };
      currentErrors['format'] = true;
      ctrl.setErrors(currentErrors);
      return;
    }
    setTimeout(() => {
      this.priceInputRegistForm.controls[targetItem].setValue(targetMoney);
    }, 1);

  }

  /**
   * フォーカスアウト時のカンマ編集
   * @memberof Sgkb714dBulksetComponent
   */
  onBlurNumberComma(targetItem: string): void {
    let targetMoney: string = this.priceInputRegistForm.controls[targetItem].value.toString();
    let commaMoney: string = this.moneyFormatService.formatMoney(targetMoney);
    // カンマの数取得
    let commaArray: string[] = commaMoney.match(/,/g);
    let commaCount: number = 0;
    if (commaArray != null) {
      commaCount = commaArray.length
    }
    // カンマの数と元々の最大桁数をmaxlengthに設定
    if (targetItem === 'waribikiKingaku') {
      this.numberCommaMaxLength1 = this.constNumberCommaMaxLength1 + commaCount;
    }
    if (targetItem === 'waribikiRitsu') {
      this.numberCommaMaxLength2 = this.constNumberCommaMaxLength2 + commaCount;
    }
    setTimeout(() => {
      this.priceInputRegistForm.controls[targetItem].setValue(commaMoney);
    }, 1);
  }

  /**
   * フォーカスイン時のカンマ編集
   * @memberof Sgkb714dBulksetComponent
   */
  onFocusNumberComma(targetItem: string): void {
    let targetMoney: string = this.priceInputRegistForm.controls[targetItem].value;
    let noCommatMoney: string = this.moneyFormatService.reformatMoney(targetMoney);
    if (targetItem === 'waribikiKingaku') {
      this.numberCommaMaxLength1 = this.constNumberCommaMaxLength1;
    }
    if (targetItem === 'waribikiRitsu') {
      this.numberCommaMaxLength2 = this.constNumberCommaMaxLength2;
    }
    this.priceInputRegistForm.controls[targetItem].setValue(noCommatMoney);
  }

}
